

let Reducer = ({
    loading: true,
    step: 1,
    isFailed: false,
    monthSliderVal: '',
    errMesasage: '',
    otpExpire: '',
   // paymentToken: getCookie('kipaa_pt'),
    paymentToken: "eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwidHlwIjoiSldUIn0.HwcGAouhPXmsqk8sPTqsTGYRUpN1MGUf_K-jM3AeNEvpAa22xGkoIA.HMYLp14hLFvcat5TGhFapQ.-YxdmEzgaeGaovLkLJK4sclClac7R4agW4FCKaqgSQUe7_m1lc849VvL8K9ITwuZ5HQa0oA113yWc2TcBZv3ge5U5Eeqoa_0D8RDrCqbq99NVhxB6IGogZ4ZpIGLcI66Sbsi5tLdh9aLr_XjFe3b35kdTMw-uEnwwmHdttjwebjvRpKnjt0GraEaCSYHL0kkaWWpVOI2B-K-6oNTFMjQLyAE4sDVhxk3g2eFUd1SpzmK03bjIzy1QU8fI8xXNqoitJdAsX4V544tOoTR6gZuEgTlasrSz-ord_7pKSYLYZetP2XESPUDxz2P5fGYAQ_sus3EhFxtl-Q83pH0Ef4hH9s_vwbumE33mESWWRwfIhrmXckO5I6_GcHUS4lZDOZNoKZOUuC4PVFjXANUK-3eXjCZWY32aqk5QdGCnj8-HIx8LrYOxNzpICGhPXVC-NWslWUXil7fHp4cXl3CkXG6AkzjZqKyB7WfQlEuF8Kd89rhQsny_EeMhF-dpeaEkcNoF3t0yQi2zFcXIqnxf9s7s-BHkgmuq1aZj4EflwhXfrLeTasc1keVD8y1eyWnDrMV0cx2esCjUnujso1t_88F82fpH7rGmUOM_G8cPfH4KEF-ax73zqBFGqiFR7AoLZksBHwqlHQG3SWjvdr0TxzhYN9hfKD2GHvy3jS4wN3sguVE2amDLsmY2w8Ux21rwaaKe-3oQ7fbwboVUb1cZJHnBcNZiVOQr2On-uceOQLpc2M.bAdsA17PXH1t9I2aYaa2QQ",
    website: localStorage.getItem("website"),
    logo: '',
    userNotFound: false,
    otpErr: false,
    terminalNum: localStorage.getItem("terminalNum"),
    supplierName: localStorage.getItem("supplierName"),
    amount: localStorage.getItem("amount"),
    sponsors: [],
    callBackUrl: localStorage.getItem('callBackUrl'),
    name: localStorage.getItem('name' || ''),
    lastName: localStorage.getItem('lastName'),
    nationalCode: localStorage.getItem('nationalCode'),
    customerAccessToken: localStorage.getItem('customerAccessToken'),
    reload: false,
    minRecepCredit:  localStorage.getItem('minCredit'),
    maxRecepCredit: localStorage.getItem('maxCredit'),
    userMonthCredit: localStorage.getItem('userMonthCredit'),
    userRemainMonthCredit: localStorage.getItem('userRemainMonthCredit'),
    maxRemainCredit: localStorage.getItem("maxRemainCredit"),
    debt: JSON.parse(localStorage.getItem('debts') || "[]"),
    cashAmount: localStorage.getItem('cashAmount'),
    recipetCode: '',
    interest:  localStorage.getItem('interest'),
    minContractCredit: localStorage.getItem('minContractCredit'),
    maxContractCredit: localStorage.getItem('maxContractCredit'),
    minDebtMonth: localStorage.getItem('minDebtMonth'),
    selectedSponsorVal: '',
    userSponsor: localStorage.getItem("userSponsor"),
    A: 0, //min of ipg credit
    B: 0, //max of ipg credit
    Beta: 0, //default of ipg credit
    isSlider: true,
    hideConfirmBtn: true,
    noContract: false,
    smsFailed: false,
    minCreditError: false,
    AuthGeneralErr: false,
    serverErr: false,
    showModalErr: false,
    transactionTimer: false,
    buttonLoading: false,
    sponsorsOptions: null,
    buttonDisabled: false,
    branchName: '',
    ManySmsReq: false,
    branchCode: ' '
});

export default Reducer